import React from "react";
import {Delete, translate} from "admin-on-rest";
import StoreDataList from "./StoreDataList";
import StoreEditForm from "./StoreEditForm";
import StoreCreateForm from "./StoreCreateForm";

///////////////////// LIST ALL STORES /////////////////////
export const StoreList = props => <StoreDataList {...props} />;

///////////////////// UPDATE STORE /////////////////////
export const StoreEdit = props => <StoreEditForm {...props} />;

///////////////////// CREATE NEW STORE /////////////////////
export const StoreCreate = props => <StoreCreateForm {...props} />;

///////////////////// DELETE STORE /////////////////////
const StoreDeleteTitleBase = ({record, translate}) => (
  <span>
    {translate("aor.action.delete")}&nbsp;
    {record && <img src={`${record.avatar}?size=25x25`} width="25" alt="" />}
    {record && `${record.name}`}
  </span>
);

const StoreDeleteTitle = translate(StoreDeleteTitleBase);

export const StoreDelete = props => (
  <Delete {...props} title={<StoreDeleteTitle />} />
);



// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/index.js